import { render, staticRenderFns } from "./scenicSet.vue?vue&type=template&id=4f846c82&scoped=true&"
import script from "./scenicSet.vue?vue&type=script&lang=js&"
export * from "./scenicSet.vue?vue&type=script&lang=js&"
import style0 from "./scenicSet.vue?vue&type=style&index=0&id=4f846c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f846c82",
  null
  
)

export default component.exports